import React, { useState } from "react";
import ProjectCard from "./ProjectCard";
import { useSpring, animated } from "react-spring";
import "../css/App.css";

export default function Work() {
  // const [heights,setHeights]=useState(true)
  const props = useSpring({
    from: { opacity: 0, marginLeft: -150 },
    to: { opacity: 1, marginLeft: 0 },
    config: { mass: 1, tension: 300, friction: 100 },
  });

  // const devCol = {
  //   heading: "DevColony",
  //   content: "Dev Colony for democratizing mentorships for everyone",
  //   github: "https://portfolioneeleshwar.netlify.app/",
  //   live: "https://devcol.vercel.app/",
  //   techs: "ReactJS,tailwind,nodeJS,Firebase",
  // };

  const nftMarketPlace = {
    heading: "NFT MarketPlace",
    content:
      "A complete solution for NFT's sale and purchase,Complete Marketplace with versions SingleVendor and Multivendor.",
    github: "",
    live: "https://nftkart.queppelinsolutions.com/",
    techs: "NextJS,Solidity,nodeJS,MaterialUI,MongoDB",
  };
  const nftGenerator = {
    heading: "NFT Generator",
    content: "",
    github: "",
    live: "https://bulknftcreator.queppelinsolutions.com/",
    techs: "NextJS,Solidity,Tailwind,nodeJS",
  };
  const bnfDrive = {
    heading: "BNF-Drive",
    content:
      "Cloud storage web app to keep all your photos,videos and documents safe",
    github: "https://github.com/neeleshwark17/bnf-drive",
    live: "https://bnf-drive.netlify.app/",
    techs: "ReactJS,css,firebase,react-bootstrap",
  };
  const bnfChats = {
    heading: "BNF-Chats",
    content:
      "An chat app developed in ReactJS using socketIO library and nodeJS",
    github: "https://github.com/neeleshwark17/bnf-chats",
    live: "https://bnf-chats.herokuapp.com/",
    techs: "ReactJS,css,nodeJS",
  };
  const chatter = {
    heading: "Chatter",
    content: "Realtime chat App developed in ReactJS and chatEngine IO",
    github: "https://github.com/neeleshwark17/chatter",
    live: "https://chatter-fe.netlify.app/",
    techs: "ReactJS,chatEngineIO,css",
  };

  // const TaskAssigner = {
  //   heading: "TaskAssigner",
  //   content:
  //     "Task assigner application, developed in express nodeJS and mongoDB",
  //   github: "https://github.com/neeleshwark17/task_assigner",
  //   live: "https://task-assigner-node-deploy.herokuapp.com/",
  //   techs: "ExpressJS,MongoDB",
  // };

  const bnfDocs = {
    heading: "BNF-Docs",
    content: "Realtime docs for keeping documents up to date developed in MERN",
    github: "https://github.com/neeleshwark17/bnf-doc",
    live: "https://bnf-docs.herokuapp.com/",
    techs: "ReactJS,nodeJS,ExpressJS,MongoDB",
  };
  const clickPts = {
    heading: "ClickPts",
    content: "Mobile app for Client, developed in android studio with java",
    github: "https://github.com/neeleshwark17/ClickPts",
    live: "https://play.google.com/store/apps/details?id=com.clickpts.clickpts",
    techs: "Android Studio,java",
  };
  const Notes = {
    heading: "Notes",
    content:
      "Notes taking application for android, developed in flutter with dart",
    github: "https://github.com/neeleshwark17/notepad_flutter",
    live: "https://play.google.com/store/apps/details?id=com.notespackage.notes",
    techs: "Flutter,Dart",
  };

  const bnfSeeTime = {
    heading: "BNF-SeeTime",
    content: "Realtime peer to peer video call app in expressJS and peerjs",
    github: "https://github.com/neeleshwark17/bnf-seetime",
    live: "https://portfolioneeleshwar.netlify.app/Work",
    techs: "ExpressJS,nodeJS",
  };
  return (
    <div
      style={{ overflowY: "auto", overflowX: "hidden", height: "100vh" }}
      id="projectScroll"
    >
      <animated.div style={props}>
        <div className="container-fluid mt-5 align-items-center justify-content-center">
          <div className=" row " style={{ marginBottom: "50px" }} id="workBox">
            {/* <ProjectCard data={devCol} /> */}
            <ProjectCard data={nftMarketPlace} />
            <ProjectCard data={bnfDrive} />
            <ProjectCard data={bnfDrive} />
            <ProjectCard data={bnfChats} />
            <ProjectCard data={chatter} />
            <ProjectCard data={bnfDocs} />
            <ProjectCard data={clickPts} />
            <ProjectCard data={Notes} />
            <ProjectCard data={bnfSeeTime} />
            {/* <ProjectCard data={TaskAssigner} id="lastCard" /> */}
          </div>
        </div>
      </animated.div>
    </div>
  );
}
